export const findClass = (state,id) => {

    const PartIndex = state.findIndex(p =>
        {
          return p.id === id;
        })

        const part = {
            ...state[PartIndex]
          }

          return part.class
          console.log('barva',part.class)

}